const Limit =() => {

    return(
        <>
            <div className="limit limit_container">
                <div className="limit_content">
                    <div className="limit_head">
                        
                        <h2>head</h2>
                    </div>
                    <div className="limit_body">
                        
                        <h2>body</h2>
                    </div>
                    <div className="limit_footer">
                        
                        <h2>footer</h2>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Limit;